import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/Tabs/SelfContainedTabs';
import { AppState } from '../../../../../../types/store';
import { getTimePeriod } from '../../../../../selectors/statsSection';
import { setTimePeriod } from '../../../../../actions/statsSection';
import { StatsTimePeriod } from '../../../../../../types/statsSection';

export type StaticProps = Pick<Props, 'items'>;
export type StateProps = Pick<Props, 'activeIndex'>;
export type DispatchProps = Pick<Props, 'onChange'>;
export type OwnProps = Without<
  Props,
  keyof (StaticProps & StateProps & DispatchProps)
>;

const switcherItems = [
  { index: StatsTimePeriod.Week, labelTransKey: 'pages.stats.week' },
  { index: StatsTimePeriod.Month, labelTransKey: 'pages.stats.month' },
  { index: StatsTimePeriod.Year, labelTransKey: 'pages.stats.year' },
];

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const activeTimePeriod = getTimePeriod(state);
  return {
    items: switcherItems,
    activeIndex: activeTimePeriod,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onChange: setTimePeriod,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
